import React from 'react';
import { AnimatedRouter as Router } from '../../components/AnimatedRouter';
import HeaderRoutes from '../Utils/Routes/header.routes';
import { generateRoutes } from '../Utils/generateRoutes';

const HeaderRouter = ({ actionSelector }: { actionSelector: any }) => (
  <Router className="header-router">{generateRoutes(HeaderRoutes, actionSelector)}</Router>
);

export default HeaderRouter;
